import React, { useEffect, useState } from 'react'
import { APIURL } from '../../config';
import axios from 'axios'
import ContactTile from './ContactTile'
import './recent_call.css'
import moment from 'moment'
import MessagePage from '../MessagePages/MessagePage'

const displayValue = (value, fallback = '') => {
    if (value === null || value === undefined) return fallback

    const normalized = String(value).trim()
    return normalized && !['NULL', 'UNDEFINED'].includes(normalized.toUpperCase()) ? normalized : fallback
}

export default function RecentCalls(props) {
    const [contacts, setContacts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (props.user) {
            fetchRecentCalls()
        }
    }, []);

    async function fetchRecentCalls() {
        setIsLoading(true);
        let result = []
        const emp_id = props.user.emp_id
        const incoming_call = await axios.get(`${APIURL}/calls`, { params: { com_id: props.user.comp_id, emp_id: props.user.emp_id, lastN: 50 } })

        if (incoming_call.data.length > 0) {
            let calls = incoming_call.data || []
            calls = calls.filter(call => (
                call.callerDetails?.id === emp_id ||
                (call.recipientType === 'employee' && call.recpDetails?.id === emp_id)
            ))
            calls.forEach(call => {
                let result_obj = {}
                let isIncoming = call.recipientType === 'employee' && call.recpDetails?.id === emp_id
                const otherParty = isIncoming ? call.callerDetails : call.recpDetails
                result_obj.call_type = isIncoming ? 'incoming' : 'outgoing'
                result_obj.name = displayValue(otherParty?.name, call.recipientType === 'customer' ? 'Unknown customer' : 'Unknown recipient')
                result_obj.phone = displayValue(otherParty?.phone)
                result_obj.subtitle = displayValue(otherParty?.desg, call.recipientType === 'customer' ? 'Customer' : '')
                result_obj.date = call.endDateOfCall
                result_obj.duration = moment.duration(moment(call.endDateOfCall).diff(moment(call.startDateOfCall))).humanize()
                result.push(result_obj)
            })
        }

        result = result.sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 10)

        setContacts(result);
        setIsLoading(false);
    }

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', boxShadow: '0 0 5px 0px black' }}>
                <div className='contact_call_icon'>
                    <i className="fas fa-phone-alt"></i>
                </div>
                <h3 style={{ fontSize: 20, marginTop: 15 }} className="timesheet-wrapper-header">RECENT CALLS</h3>
                <div className="contact-subtitle-wrapper">
                    <p className='mt-2 p-1'>Your last 10 calls:</p>
                </div>
            </div>
            <div style={{ overflow: 'auto', padding: '10px' }}>
                <div>
                    {!!isLoading &&
                        <div className='d-flex flex-row w-100 justify-content-center mt-5'>
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    }
                    {!isLoading && contacts.length === 0 &&
                        <div style={{ margin: 30, height: '100%' }} className='d-flex flex-column justify-content-center align-items-center'>
                            {<MessagePage title="No Recent Calls Found" icon="fas fa-phone-alt"></MessagePage>}
                        </div>
                    }
                    {
                        contacts.map((item, index) => (
                            <div key={index}>
                                <ContactTile
                                    name={item.name}
                                    phone={item.phone}
                                    subtitle={item.subtitle}
                                    incoming={item.call_type === 'incoming'}
                                    outgoing={item.call_type === 'outgoing'}
                                    dateTime={`${item.date.split('T')[0]} | ${item.date.split('T')[1]}`}
                                    duration={item.duration}
                                />
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
};
